<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import AppShell from './components/AppShell.vue';
import ConfirmDialog from './components/ConfirmDialog.vue';

const auth = useAuthStore();
const { t } = useI18n();
const deactivated = ref(new URLSearchParams(window.location.search).get('deactivated') === '1');
onMounted(() => { auth.fetchMe(); });
</script>

<template>
  <div v-if="auth.loading" class="boot">{{ t('common.loading') }}</div>

  <div v-else-if="auth.needsLogin" class="login-screen">
    <div class="login-card">
      <div class="login-brand">
        <img src="/timeoff-icon.png" alt="" class="login-mark" />
        <h1 class="login-title">Z&amp;V Timeoff</h1>
      </div>

      <div class="login-rule"></div>

      <p v-if="deactivated" class="login-deactivated">{{ t('login.deactivated') }}</p>
      <p v-else class="login-text">{{ t('login.prompt') }}</p>
      <button v-if="!deactivated" class="btn-primary login-btn" @click="auth.login">{{ t('common.signInWithSso') }}</button>
    </div>
  </div>

  <AppShell v-else />

  <ConfirmDialog />
</template>

<style scoped>
.boot { padding: 4rem; text-align: center; color: var(--outline); font-size: 13px; letter-spacing: 0.02em; }

.login-screen {
  min-height: 100vh;
  display: flex; align-items: center; justify-content: center;
  background: var(--surface);
}
.login-card {
  background: var(--surface-container-lowest);
  border: 1px solid var(--surface-container-highest);
  padding: 48px 40px;
  width: 100%; max-width: 420px;
  text-align: left;
}
.login-brand { display: flex; align-items: center; gap: 14px; margin-bottom: 6px; }
.login-mark {
  width: 44px; height: 44px;
  object-fit: contain;
  display: block;
}
.login-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 22px; font-weight: 700;
  letter-spacing: -0.01em; text-transform: uppercase;
  margin: 0; color: var(--primary);
}
.login-rule { height: 1px; background: var(--surface-container-highest); margin: 32px 0; }
.login-text { font-size: 14px; line-height: 1.6; color: var(--on-surface-variant); margin: 0 0 24px; }
.login-deactivated { font-size: 14px; line-height: 1.6; color: var(--secondary); margin: 0; padding: 16px; border-left: 2px solid var(--secondary); background: rgba(182,20,44,0.06); }
.login-btn { width: 100%; justify-content: center; padding: 14px 20px; }
</style>
